import { TideData } from 'types/tide';
import { Height, Units } from 'types/units';
import { WindData } from 'types/wind';

interface DataPoint {
  timestamp: number;
  wind: {
    speed_ms: number;
    direction_deg?: number;
  };
  tide_m: number;
}

export interface SwellSigRequest {
  queryParams: any;
  spot: {
    id: string;
  };
  data: DataPoint[];
}

const convertFeetToMeters = (feet: number) => feet / 3.281;

const convertWindToMetersPerSeconds = (speed: number, currentUnits: string) => {
  if (currentUnits === 'KPH') {
    return speed / 3.6;
  }
  if (currentUnits === 'MPH') {
    return speed / 2.237;
  }
  // must be knots
  return speed / 1.944;
};

const convertTideHeightToMeters = (tide: number, currentUnits: Height) => {
  if (currentUnits === 'FT') {
    return convertFeetToMeters(tide);
  }
  return tide;
};

export const convertToSwellSigRequest = ({
  spotId,
  wind,
  tide,
  userUnits,
  queryParams,
}: {
  spotId: string;
  wind: WindData;
  tide: TideData;
  userUnits: Units;
  queryParams: any;
}): SwellSigRequest | null => {
  if (!wind?.days || !tide?.days) {
    return null;
  }

  const filteredTideForNormalHourlyIncrements = tide.days.map((day) =>
    day.filter((d) => d.type === 'NORMAL'),
  );

  const data = wind?.days?.map((day, dayIndex) =>
    day.map((hour, hourIndex) => ({
      timestamp: hour.timestamp,
      wind: {
        speed_ms: convertWindToMetersPerSeconds(
          wind.days[dayIndex][hourIndex].speed,
          userUnits.windSpeed,
        ),
        direction_deg: wind.days[dayIndex][hourIndex].direction,
      },
      tide_m: convertTideHeightToMeters(
        filteredTideForNormalHourlyIncrements[dayIndex][hourIndex].height,
        userUnits.tideHeight as Height,
      ),
    })),
  );

  return {
    spot: {
      id: spotId,
    },
    data: data.flat(),
    queryParams,
  };
};
